import { LocalizationHelper } from '../helpers/localization/localization.helper.ts';

type Keys =
  | 'settings'
  | 'search'
  | 'sort'
  | 'clear'
  | 'avatar'
  | 'no_data'
  | 'company_settings'
  | 'profile_settings'
  | 'language'
  | 'currency'
  | 'no_data_in_global_search'
  | 'name'
  | 'show_filters'
  | 'hide_filters'
  | 'number'
  | 'sending_to_printer'
  | 'assign_printers_first'
  | 'print_jobs_created'
  | 'print_jobs_created_with_errors'
  | 'vat'
  | 'note'
  | 'configure'
  | 'filter'
  | 'successfully_saved'
  | 'confirm'
  | 'download_files'
  | 'add'
  | 'select_existing_customer'
  | 'remove'
  | 'font_color'
  | 'font_size'
  | 'font'
  | 'analyzing_results'
  | 'deep_thinking'
  | 'thank_you_patience'
  | 'just_moment'
  | 'crafting_perfect_result'
  | 'charting_optimal_path'
  | 'calculating_best_way'
  | 'working_might_take_minute'
  | 'almost_there'
  | 'everything_ready_shortly'
  | 'checking_final_details'
  | 'request_top_priority'
  | 'new_values'
  | 'confirmation'
  | 'do_you_agree'
  | 'changes_summary'
  | 'show_changes'
  | 'hide_changes'
  | 'applyConfirmation'
  | 'applyConfirmation_other'
  | 'confirmInstruction'
  // errors messages -->
  | 'error_customer_info_not_loaded'
  | 'error_customer_list_not_loaded'
  | 'error_orders_not_loaded'
  | 'street_or_post_office_box_should_be_selected'
  // <-- errors messages
  | 'cancel'
  | 'history'
  | 'current_entry'
  | 'deleted_entries'
  | 'date'
  | 'more_functions'
  | 'date_time'
  | 'operation'
  | 'username'
  | 'field'
  | 'article_no'
  | 'delivery_no'
  | 'brutto'
  | 'net'
  | 'user'
  | 'assist'
  | 'cash'
  | 'wawi'
  | 'rezept'
  | 'smart'
  | 'picking'
  | 'restaurant'
  | 'manager'
  | 'run'
  | 'my_resto'
  | 'console'
  | 'grouping'
  | 'old_value'
  | 'new_value'
  | 'content'
  | 'lot_quantity'
  | 'not_empty'
  | 'only_numbers'
  | 'loading'
  | 'search_failed'
  | 'search_result_for'
  | 'value_between'
  | 'value_less'
  | 'value_less_or_equal'
  | 'value_less_999_99'
  | 'value_greater'
  | 'description'
  | 'activated'
  | 'cash_register_id'
  | 'cashassist'
  | 'receipt_no'
  | 'delivery_method'
  | 'cashassist_user'
  | 'permitted'
  | 'forbidden'
  | 'address'
  | 'enter_delivery_address'
  | 'print'
  | 'print_all'
  | 'download'
  | 'email'
  | 'empty'
  | 'export'
  | 'delivery_note'
  | 'invoice'
  | 'preview'
  | 'preview_all'
  | 'successfully'
  | 'multiselect'
  | 'server_error'
  | 'error_chnages_not_saved'
  | 'proceed_anyway'
  | 'warning'
  | 'current_month'
  | 'save'
  | 'last_month'
  | 'date_range'
  | 'customer'
  | 'customer_no'
  | 'customers_group'
  | 'customers_list'
  | 'one_time_customers'
  | 'open_emails'
  | 'sending_emails'
  | 'sent_emails'
  | 'show_deleted'
  | 'from'
  | 'to'
  | 'ok'
  | 'pdf_history'
  | 'pdfs_versions'
  | 'created'
  | 'invalid_data_warning'
  | 'report'
  | 'report_preview'
  | 'sending'
  | 'send'
  | 'email_sent_successfully'
  | 'email_sent_successfully_other'
  | 'problem_while_sending_email'
  | 'problem_while_sending_email_other'
  | 'order'
  | 'offer'
  | 'recipient'
  | 'article'
  | 'regarding'
  | 'message'
  | 'from_date'
  | 'to_date'
  | 'yearly'
  | 'rules_is_not_set'
  | 'regional_datetime_entered_day_of_week'
  | 'in_period'
  | 'repeat_yearly'
  | 'in_periods'
  | 'vacation'
  | 'not_delivered'
  | 'change'
  | 'fri'
  | 'mon'
  | 'sat'
  | 'sun'
  | 'thu'
  | 'tue'
  | 'wed'
  | 'january'
  | 'february'
  | 'march'
  | 'april'
  | 'may'
  | 'june'
  | 'july'
  | 'august'
  | 'september'
  | 'october'
  | 'november'
  | 'december'
  | 'jan'
  | 'feb'
  | 'mar'
  | 'apr'
  | 'may_short'
  | 'jun'
  | 'jul'
  | 'aug'
  | 'sep'
  | 'oct'
  | 'nov'
  | 'dec'
  | 'hours'
  | 'minutes'
  | 'facilities'
  | 'number_short'
  | 'offline'
  | 'internet_restored'
  | 'new_version_installed'
  | 'update'
  | 'session_expired'
  | 'sign_out'
  | 'signed_out_refresh'
  | 'refresh'
  | 'reload_page'
  | 'monday'
  | 'revert_changes'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday'
  | 'replace'
  | 'weekAgo'
  | 'twoWeeksAgo'
  | 'threeWeeksAgo'
  | 'changes_you_made_were_not_saved'
  | 'all_lists'
  | 'all_types'
  | 'default_settings'
  | 'additional'
  | 'enter_valid_email'
  | 'days'
  | 'update_browser_heading'
  | 'update_browser_message'
  | 'link_current_browser_versions'
  | 'max'
  | 'min'
  | 'category'
  | 'successfully_deleted'
  | 'close'
  | 'apply'
  | 'all'
  | 'shown'
  | 'show_all'
  | 'amount'
  | 'discount'
  | 'delete'
  | 'do_you_want_unbind_and_delete'
  | 'emails'
  | 'mailing_message'
  | 'emails_sent_successfully'
  | 'emails_failed_to_send'
  | 'error_while_sending_emails'
  | 'previous_record'
  | 'next_record'
  | 'quantity'
  | 'correction_quantity'
  | 'yes'
  | 'no'
  | 'new_record'
  | 'report_is_generating_now'
  | 'discard_your_changes'
  | 'discard'
  | 'difference'
  | 'list_are_not_configured'
  | 'click_button_above_to_configure'
  | 'invoice_dates_range'
  | 'track'
  | 'sender_address'
  | 'receiver_address'
  | 'subject'
  | 'diagnostic_information'
  | 'delivery_information_is_not_yet_available'
  | 'data_processing'
  | 'price'
  | 'price_pre_discount'
  | 'price_after_discount'
  | 'total'
  | 'total_pre_discount'
  | 'total_after_discount'
  | 'save_to_date'
  | 'thinking'
  | 'fetching_data_from_the_cloud'
  | 'thank_you_for_your_patience'
  | 'just_a_moment_we_are_processing_your_request'
  | 'gathering_your_data'
  | 'round_to'
  | 'new'
  | 'picture'
  | 'for'
  | 'serial_no'
  | 'print_form'
  | 'print_forms'
  | 'password'
  | 'step'
  | 'submit'
  | 'next'
  | 'back'
  | 'multi_edit_settings'
  | 'finished'
  | 'import'
  | 'printer'
  | 'customer_not_uses_this_print_form'
  | 'invite'
  | 'rights'
  | 'reason'
  | 'contact_administrator'
  | 'saving_in_progress'
  | 'deleting_in_progress'
  | 'delete_success'
  | 'delete_failed'
  | 'translations'
  | 'saved_successfully'
  | 'saving_error_try_again'
  | 'the_image_size_must_be_less_than_x_kb'
  | 'image_width_must_be_less_than_x_px'
  | 'image_height_must_be_less_than_x_px'
  | 'default'
  | 'custom'
  | 'translate_with_ai'
  | 'validation_error'
  | 'version'
  | 'new_version_available';

const t = LocalizationHelper<Keys>('common');

export const commonDe = t({
  the_image_size_must_be_less_than_x_kb: 'Die Bildgröße muss kleiner als {{size}} KB sein',
  image_width_must_be_less_than_x_px: 'Die Bildbreite muss kleiner als {{size}} px sein',
  image_height_must_be_less_than_x_px: 'Die Bildhöhe muss kleiner als {{size}} px sein',
  saving_error_try_again: 'Fehler beim Speichern, bitte erneut versuchen.',
  saved_successfully: 'Erfolgreich gespeichert',
  deleting_in_progress: 'Löschen läuft',
  delete_success: 'Erfolgreich gelöscht',
  delete_failed: 'Löschen fehlgeschlagen',
  saving_in_progress: 'Speichern läuft',
  reason: 'Grund',
  rights: 'Rechte',
  invite: 'Einladen',
  printer: 'Drucker',
  import: 'Importieren',
  finished: 'Fertig',
  confirmInstruction:
    'Um fortzufahren, geben Sie bitte <strong>„Number of edited items"</strong> in das obige Feld ein und klicken Sie anschließend auf die Schaltfläche „Submit" unten.',
  applyConfirmation:
    'Die Änderungen werden dauerhaft auf das <b>{{count}} ausgewählte Element</b> angewendet.',
  applyConfirmation_other:
    'Die Änderungen werden dauerhaft auf die <b>{{count}} ausgewählten Elemente</b> angewendet.',
  confirmation: 'Bestätigung',
  company_settings: 'Unternehmenseinstellungen',
  profile_settings: 'Profileinstellungen',
  language: 'Sprache',
  currency: 'Währung',
  changes_summary: 'Änderungsübersicht',
  select_existing_customer: 'Vorhandenen Kunden auswählen',
  show_changes: 'Änderungen anzeigen',
  hide_changes: 'Änderungen ausblenden',
  sending_to_printer: 'Wird an den Drucker gesendet',
  assign_printers_first: 'Bitte weisen Sie zunächst Drucker zu, um Formulare zu drucken',
  print_jobs_created: 'Druckaufträge erstellt: {{countCreated}}',
  print_jobs_created_with_errors:
    'Druckaufträge erstellt: {{countCreated}} ({{countErrors}} Fehler)',
  do_you_agree: 'Stimmen Sie zu?',
  new_values: 'Neue Werte',
  multi_edit_settings: 'Einstellungen für Mehrfachbearbeitung',
  back: 'Zurück',
  next: 'Weiter',
  submit: 'Senden',
  step: 'Schritt',
  password: 'Passwort',
  settings: 'Einstellungen',
  add: 'Hinzufügen',
  thinking: 'Verarbeitung läuft…',
  fetching_data_from_the_cloud: 'Daten werden aus der Cloud geladen...',
  thank_you_for_your_patience:
    'Vielen Dank für Ihre Geduld – wir bereiten die bestmögliche Antwort vor...',
  just_a_moment_we_are_processing_your_request:
    'Ihre Anfrage wird verarbeitet – einen Moment bitte...',
  gathering_your_data: 'Daten werden gesammelt...',
  remove: 'Löschen',
  download_files: 'Dateien herunterladen',
  download: 'Herunterladen',
  all: 'Gesamt',
  street_or_post_office_box_should_be_selected: '"Strasse" oder "Postfach" muss ausgefüllt sein',
  all_types: 'Alle Typen',
  name: 'Name',
  number: 'Nummer',
  search: 'Suchen',
  article: 'Artikel',
  sort: 'Sorte',
  clear: 'Klar',
  show_filters: 'Filter anzeigen',
  hide_filters: 'Filter ausblenden',
  no_data: 'Keine Daten',
  vat: 'MwSt',
  avatar: 'Avatar',
  shown: 'Gezeigt',
  show_all: 'Zeige alles',
  search_failed: 'Suche fehlgeschlagen',
  search_result_for: 'Suchergebnis für',
  note: 'Bemerkung',
  configure: 'Konfigurieren',
  filter: 'Filter',
  confirm: 'Bestätigen',
  font_color: 'Schriftfarbe',
  font_size: 'Schriftgröße',
  cancel: 'Abbrechen',
  history: 'Verlauf',
  brutto: 'Brutto',
  net: 'Netto',
  user: 'Benutzer',
  grouping: 'Gruppierung',
  current_entry: 'Aktueller Eintrag',
  deleted_entries: 'Gelöschte Einträge',
  date: 'Datum',
  rules_is_not_set: 'Es sind keine Regeln festgelegt',
  regional_datetime_entered_day_of_week: 'Jeden {{days}}',
  in_period: 'in der Zeit',
  repeat_yearly: 'Wiederhole jährlich',
  in_periods: 'in der Zeit {{periods}}',
  vacation: 'Urlaub',
  not_delivered: 'Nicht verfügbar',
  from_date: 'Von Datum',
  to_date: 'Bis Datum',
  yearly: 'Jährlich',
  change: 'Veränderung',
  assist: 'Assist',
  cash: 'Cash',
  wawi: 'Wawi',
  rezept: 'Rezept',
  smart: 'Smart',
  picking: 'Picking',
  restaurant: 'Restaurant',
  manager: 'Manager',
  run: 'Run',
  my_resto: 'MyResto',
  console: 'Console',
  fri: 'Fr',
  mon: 'Mo',
  sat: 'Sa',
  sun: 'So',
  thu: 'Do',
  tue: 'Di',
  wed: 'Mi',
  date_time: 'Datum/Zeit',
  operation: 'Operation',
  username: 'Benutzername',
  field: 'Field',
  successfully_saved: 'Erfolgreich gespeichert',
  successfully_deleted: 'Erfolgreich gelöscht',
  more_functions: 'Mehr Funktion',
  article_no: 'Artikel-Nr.',
  delivery_no: 'Lieferschein-Nr.',
  old_value: 'Alter Wert',
  new_value: 'Neuer Wert',
  content: 'Inhalt',
  lot_quantity: 'Der Wert muss ein Vielfaches der Anzahl der Lots sein',
  not_empty: 'Eingabe erforderlich',
  only_numbers: 'Sollte nur Zahlen enthalten',
  value_between: 'Der Wert muss zwischen liegen {{min}} und {{max}}',
  value_less: 'Der Wert muss kleiner als {{max}} sein',
  value_less_or_equal: 'Der Wert darf nicht größer als {{max}} sein',
  value_less_999_99: 'Der Wert muss kleiner als 999,99 sein',
  value_greater: 'Der Wert muss größer sein als {{min}}',
  loading: 'Wird geladen...',
  description: 'Bezeichnung',
  activated: 'Aktiviert',
  permitted: 'Erlaubt',
  forbidden: 'Verboten',
  address: 'Adresse',
  enter_delivery_address: 'Lieferadresse eingeben',
  empty: 'Leer',
  export: 'Exportieren',
  print: 'Drucken',
  print_all: 'Alle drucken',
  email: 'Email',
  revert_changes: 'Änderungen rückgängig machen',
  delivery_note: 'Lieferschein',
  invoice: 'Rechnung',
  preview: 'Vorschau',
  preview_all: 'Alle in der Vorschau anzeigen',
  successfully: 'Erfolgreich',
  server_error: 'Serverfehler',
  multiselect: 'Mehrfachauswahl',
  proceed_anyway: 'Fahre dennoch fort',
  cash_register_id: 'Kasse ID',
  cashassist: 'CashAssist',
  delivery_method: 'Lieferart',
  receipt_no: 'Beleg-Nr',
  cashassist_user: 'CashAssist Benutzer',
  warning: 'Warnung',
  current_month: 'Aktueller Monat',
  last_month: 'Letzter Monat',
  date_range: 'Datumsbereich',
  customer: 'Kunde',
  customer_no: 'Kunden-Nr.',
  customers_group: 'Kundengruppe',
  customers_list: 'Kundenliste',
  one_time_customers: 'Einmalkunden',
  open_emails: 'Offene Emails',
  sending_emails: 'Emails senden in Bearbeitung',
  sent_emails: 'Versendete Emails',
  show_deleted: 'Gelöschte anzeigen',
  from: 'Von',
  to: 'Bis',
  pdf_history: 'PDF Verlauf',
  pdfs_versions: 'PDFs Verlauf',
  created: 'Erstellt',
  report: 'Bericht',
  ok: 'Ok',
  invalid_data_warning:
    'Die Daten waren ungültig. Ihre Änderungen gehen verloren. Möchten Sie fortfahren?',
  sending: 'Senden...',
  send: 'Senden',
  email_sent_successfully: 'E-Mails wurde erfolgreich Versendet',
  email_sent_successfully_other: 'E-Mails wurden erfolgreich gesendet',
  problem_while_sending_email: 'Problem beim Senden der E-Mail',
  problem_while_sending_email_other: 'Problem beim Senden von E-Mails',
  order: 'Bestellung',
  offer: 'Angebot',
  recipient: 'Empfänger',
  regarding: 'Betreff',
  message: 'Meldung',
  facilities: 'Anlagen',
  number_short: 'Nr.',
  offline: 'Du bist offline',
  internet_restored: 'Internetverbindung wiederhergestellt',
  new_version_installed:
    'Herzlichen Glückwunsch 🎉 Das Update auf die neue Version war erfolgreich!',
  update: 'Aktualisieren',
  session_expired: 'Sitzung abgelaufen',
  sign_out: 'Abmelden',
  signed_out_refresh:
    'Sie sind abgemeldet. Aktualisieren Sie die Seite, um mit der Arbeit fortzufahren.',
  refresh: 'Aktualisieren',
  reload_page: 'Seite neuladen',
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  save: 'Speichern',
  sunday: 'Sonntag',
  replace: 'Ersetzen',
  weekAgo: 'Vor einer Woche',
  twoWeeksAgo: 'Vor zwei Wochen',
  threeWeeksAgo: 'Vor drei Wochen',
  no_data_in_global_search: 'Ihre Suche „{{searchString}}“ hat keine Dokumente ergeben',
  error_customer_info_not_loaded: 'Kundeninformationen wurden nicht geladen!',
  error_customer_list_not_loaded: 'Kundenliste wurde nicht geladen!',
  error_orders_not_loaded: 'Bestellung wurde nicht geladen!',
  error_chnages_not_saved: 'Fehler. Ihre Änderungen wurden nicht gespeichert.',
  changes_you_made_were_not_saved:
    'Die von Ihnen vorgenommenen Änderungen wurden nicht gespeichert. Möchten Sie fortfahren?',
  all_lists: 'Alle Listen',
  default_settings: 'Standardeinstellung',
  additional: 'Zusätzlich',
  days: 'Tage',
  enter_valid_email: 'Geben Sie eine gültige Email Adresse ein',
  update_browser_heading: 'Aktualisieren Sie Ihren Browser',
  update_browser_message:
    'Leider verwenden Sie einen veralteten Browser. <br /> Bitte aktualisieren Sie Ihren Browser, um Ihr Erlebnis und Ihre Sicherheit zu verbessern.',
  link_current_browser_versions: 'Links zu aktuellen Browserversionen:',
  max: 'Max',
  min: 'Min',
  category: 'Kategorie',
  close: 'Schließen',
  apply: 'Anwenden',
  amount: 'Betrag',
  discount: 'Rabatt',
  delete: 'Löschen',
  emails: 'Emails',
  do_you_want_unbind_and_delete:
    '{{dictionary}} kann nicht gelöscht werden. Es wird verwendet für die folgenden {{lists}} (siehe Details). Möchten Sie diese von der {{lists}} entfernen und die löschen?',
  mailing_message:
    'Der E-Mail Versand wird in einem seperaten Prozess nun durchgeführt.\n \nNach Ende des Prozesses erhalten Sie eine Meldung.',
  emails_sent_successfully: 'E-Mails wurden erfolgreich versendet: {{successCount}}',
  emails_failed_to_send: 'E-Mails konnten nicht gesendet werden: {{failureCount}}',
  error_while_sending_emails:
    'Beim Senden von E-Mails ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
  previous_record: 'Bisherigen Datensatz',
  next_record: 'Nächster Datensatz',
  quantity: 'Menge',
  correction_quantity: 'Korrekturmenge',
  yes: 'Ja',
  no: 'Nein',
  new_record: 'Neuer Eintrag',
  report_is_generating_now:
    'Der Bericht wird gerade erstellt. Bitte versuchen Sie es später erneut',
  discard_your_changes: 'Änderungen verwerfen?',
  discard: 'Verwerfen',
  difference: 'Differenz',
  list_are_not_configured: 'Listen sind nicht konfiguriert',
  click_button_above_to_configure:
    'Klicken Sie auf die <icon /> Schaltfläche oben, um zu konfigurieren',
  track: 'Verfolgen',
  sender_address: 'Absenderadresse',
  receiver_address: 'Empfängeradresse',
  subject: 'Betreff',
  diagnostic_information: 'Diagnoseinformationen',
  delivery_information_is_not_yet_available:
    'Die Lieferinformationen sind noch nicht verfügbar, bitte versuchen Sie es später erneut!',
  invoice_dates_range: 'Rechnung Datum Bereich',
  data_processing: 'Datenverarbeitung...',
  price: 'Preis',
  price_pre_discount: 'Preis (v. Rab.)',
  price_after_discount: 'Preis (n. Rab.)',
  total: 'Total',
  total_pre_discount: 'Total (v. Rab.)',
  total_after_discount: 'Total (n. Rab.)',
  save_to_date: 'Speichern zum Datum',
  round_to: 'Runden auf',
  new: 'Neuer',
  for: 'Für',
  serial_no: 'Serien-Nr.',
  picture: 'Bild',
  font: 'Schriftart',
  report_preview: 'Berichtsvorschau',
  print_form: 'Formular',
  print_forms: 'Formulare',
  january: 'Januar',
  february: 'Februar',
  march: 'März',
  april: 'April',
  may: 'Mai',
  june: 'Juni',
  july: 'Juli',
  august: 'August',
  september: 'September',
  october: 'Oktober',
  november: 'November',
  december: 'Dezember',
  jan: 'Jan.',
  feb: 'Feb.',
  mar: 'Mär.',
  apr: 'Apr.',
  may_short: 'Mai',
  jun: 'Jun.',
  jul: 'Jul.',
  aug: 'Aug.',
  sep: 'Sep.',
  oct: 'Okt.',
  nov: 'Nov.',
  dec: 'Dez.',
  hours: 'Stunden',
  minutes: 'Minuten',
  analyzing_results: 'Analyse läuft – Ergebnisse folgen in Kürze...',
  deep_thinking: 'Intensive Datenverarbeitung...',
  thank_you_patience: 'Wir danken für Ihre Geduld...',
  just_moment: 'Einen kurzen Moment bitte...',
  crafting_perfect_result: 'Die optimale Lösung wird erstellt...',
  charting_optimal_path: 'Wir berechnen die beste Vorgehensweise...',
  calculating_best_way: 'Ermittlung der optimalen Unterstützung läuft...',
  working_might_take_minute:
    'Wir arbeiten daran – dieser Vorgang kann bis zu einer Minute dauern...',
  almost_there: 'Fast abgeschlossen...',
  everything_ready_shortly: 'Gleich ist alles bereit...',
  checking_final_details: 'Letzte Details werden überprüft...',
  request_top_priority: 'Ihre Anfrage hat für uns höchste Priorität',
  contact_administrator: 'Bitte wenden Sie sich an Ihren Administrator.',
  customer_not_uses_this_print_form:
    'Der Kunde wurde so konfiguriert, dass dieses Druckformular nicht verwendet wird',
  translations: 'Übersetzungen',
  default: 'Standard',
  translate_with_ai: 'Mit KI übersetzen',
  custom: 'Benutzerdefiniert',
  validation_error: 'Validierungsfehler',
  version: 'Version',
  new_version_available: 'Eine neue Version ist verfügbar. Bitte die Seite neuladen.',
});

export const commonEn = t({
  saving_error_try_again: 'Saving error, try again.',
  the_image_size_must_be_less_than_x_kb: 'The image size must be less than {{size}} KB',
  image_width_must_be_less_than_x_px: 'The image width must be less than {{size}} px',
  image_height_must_be_less_than_x_px: 'The image height must be less than {{size}} px',
  saved_successfully: 'Saved successfully',
  deleting_in_progress: 'Deleting in progress',
  delete_success: 'Successfully deleted',
  delete_failed: 'Deletion failed',
  saving_in_progress: 'Saving in progress',
  reason: 'Reason',
  rights: 'Rights',
  invite: 'Invite',
  printer: 'Printer',
  import: 'Import',
  finished: 'Finished',
  confirmInstruction:
    'To proceed, please type <strong>"Number of edited items"</strong> in the field above and click the "Submit" button below.',
  applyConfirmation:
    'The changes will be permanently applied to the <b>{{count}} selected item</b>.',
  applyConfirmation_other:
    'The changes will be permanently applied to the <b>{{count}} selected items</b>.',
  confirmation: 'Confirmation',
  do_you_agree: 'Do you agree?',
  company_settings: 'Company settings',
  profile_settings: 'Profile settings',
  language: 'Language',
  currency: 'Currency',
  changes_summary: 'Changes summary',
  sending_to_printer: 'Sending to printer',
  assign_printers_first: 'Please assign printers to print forms first',
  print_jobs_created: 'Print jobs created: {{countCreated}}',
  print_jobs_created_with_errors: 'Print jobs created: {{countCreated}} ({{countErrors}} errors)',
  select_existing_customer: 'Select existing customer',
  show_changes: 'Show changes',
  hide_changes: 'Hide changes',
  new_values: 'New values',
  multi_edit_settings: 'Multi-edit settings',
  back: 'Back',
  next: 'Next',
  submit: 'Submit',
  step: 'Step',
  password: 'Password',
  settings: 'Settings',
  thinking: 'Thinking...',
  fetching_data_from_the_cloud: 'Fetching data from the cloud...',
  thank_you_for_your_patience: 'Thank you for your patience, crafting the perfect response...',
  just_a_moment_we_are_processing_your_request: 'Just a moment, we’re processing your request...',
  gathering_your_data: 'Gathering your data...',
  add: 'Add',
  all: 'All',
  download_files: 'Download files',
  download: 'Download',
  all_types: 'All types',
  remove: 'Remove',
  street_or_post_office_box_should_be_selected: '"Street" or "Post office box" should be filled',
  name: 'Name',
  number: 'Number',
  search: 'Search',
  sort: 'Sort',
  show_filters: 'Show filters',
  hide_filters: 'Hide filters',
  clear: 'Clear',
  no_data: 'No data',
  vat: 'VAT',
  note: 'Note',
  article: 'Article',
  configure: 'Configure',
  filter: 'Filter',
  confirm: 'Confirm',
  font_color: 'Font color',
  font_size: 'Font size',
  cancel: 'Cancel',
  history: 'History',
  current_entry: 'Current entry',
  deleted_entries: 'Deleted entries',
  date: 'Date',
  brutto: 'Brutto',
  avatar: 'Avatar',
  net: 'Net',
  shown: 'Shown',
  show_all: 'Show all',
  user: 'User',
  assist: 'Assist',
  cash: 'Cash',
  wawi: 'Wawi',
  rezept: 'Rezept',
  smart: 'Smart',
  picking: 'Picking',
  restaurant: 'Restaurant',
  manager: 'Manager',
  run: 'Run',
  my_resto: 'MyResto',
  console: 'Console',
  grouping: 'Grouping',
  date_time: 'Date/Time',
  operation: 'Operation',
  revert_changes: 'Revert changes',
  username: 'User name',
  field: 'Field',
  more_functions: 'More functions',
  article_no: 'Article No.',
  delivery_no: 'Order No.',
  old_value: 'Old value',
  new_value: 'New value',
  cash_register_id: 'Cash register ID',
  cashassist: 'CashAssist',
  delivery_method: 'Delivery method',
  receipt_no: 'Receipt No.',
  cashassist_user: 'CashAssist user',
  successfully_saved: 'Successfully saved',
  successfully_deleted: 'Successfully deleted',
  content: 'Content',
  lot_quantity: 'The value must be a multiple of the number of lots',
  not_empty: 'Input required',
  only_numbers: 'Should contain only numbers',
  value_between: 'The value must be between {{min}} and {{max}}',
  value_less: 'The value must be less than {{max}}',
  value_less_or_equal: 'The value must not be greater than {{max}}',
  value_less_999_99: 'The value must be less than 999.99',
  value_greater: 'The value must be greater than {{min}}',
  no_data_in_global_search: 'Your search - {{searchString}} - did not match any documents',
  loading: 'Loading...',
  description: 'Description',
  activated: 'Activated',
  search_failed: 'Search failed',
  search_result_for: 'Search result for',
  permitted: 'Permitted',
  rules_is_not_set: 'Rules is not set',
  regional_datetime_entered_day_of_week: 'Every {{days}}',
  in_period: 'in period',
  repeat_yearly: 'Repeat yearly',
  in_periods: 'in periods {{periods}}',
  vacation: 'Vacation',
  not_delivered: 'Not delivered',
  from_date: 'From date',
  to_date: 'To date',
  yearly: 'Yearly',
  change: 'Change',
  fri: 'Fr',
  mon: 'Mo',
  sat: 'Sa',
  sun: 'Su',
  thu: 'Th',
  tue: 'Tu',
  wed: 'We',
  forbidden: 'Forbidden',
  address: 'Address',
  enter_delivery_address: 'Enter delivery address',
  empty: 'Empty',
  export: 'Export',
  print: 'Print',
  print_all: 'Print all',
  email: 'Email',
  delivery_note: 'Delivery note',
  invoice: 'Invoice',
  preview: 'Preview',
  preview_all: 'Preview all',
  successfully: 'Successfully',
  server_error: 'Server error',
  multiselect: 'Multi-selection',
  proceed_anyway: 'Proceed anyway',
  warning: 'Warning',
  current_month: 'Current month',
  last_month: 'Last month',
  date_range: 'Date range',
  customer: 'Customer',
  customer_no: 'Customer No.',
  customers_group: 'Customer group',
  customers_list: 'Customer list',
  one_time_customers: 'One-time customer',
  open_emails: 'Emails not sent',
  sending_emails: 'Emails send in progress',
  sent_emails: 'Sent emails',
  show_deleted: 'Show deleted',
  from: 'From',
  to: 'To',
  pdf_history: 'PDF History',
  pdfs_versions: 'PDFs History',
  created: 'Created',
  report: 'Report',
  ok: 'Ok',
  invalid_data_warning: 'Data was invalid. Your changes will be lost. Do you want to proceed?',
  sending: 'Sending...',
  save: 'Save',
  send: 'Send',
  email_sent_successfully: 'Email was successfully sent',
  email_sent_successfully_other: 'Emails was successfully sent',
  problem_while_sending_email: 'Problem while sending email',
  problem_while_sending_email_other: 'Problem while sending emails',
  order: 'Order',
  offer: 'Offer',
  recipient: 'Recipient',
  regarding: 'Regarding',
  message: 'Message',
  facilities: 'Facilities',
  number_short: 'No.',
  offline: 'You are offline',
  internet_restored: 'Internet connection restored',
  new_version_installed: 'Congratulations 🎉 The update to the new version was successful!',
  update: 'Update',
  session_expired: 'Session expired',
  sign_out: 'Sign out',
  signed_out_refresh: 'You are signed out. Refresh the page to continue working.',
  refresh: 'Refresh',
  reload_page: 'Reload the page',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  replace: 'Replace',
  weekAgo: 'Week ago',
  twoWeeksAgo: 'Two weeks ago',
  threeWeeksAgo: 'Three weeks ago',
  error_customer_info_not_loaded: 'Customer information has not been loaded!',
  error_orders_not_loaded: 'Order was not loaded!',
  error_customer_list_not_loaded: 'Customer list was not loaded!',
  error_chnages_not_saved: 'Error. Your changes were not saved.',
  changes_you_made_were_not_saved: 'The changes you made were not saved. Do you want to proceed?',
  all_lists: 'All lists',
  default_settings: 'Default settings',
  additional: 'Additional',
  days: 'Days',
  enter_valid_email: 'Please enter a correct email address',
  update_browser_heading: 'Update your browser',
  update_browser_message:
    'Unfortunately, you are using an outdated browser.<br />Please upgrade your browser to improve your experience and security.',
  link_current_browser_versions: "Links of browser's current versions:",
  max: 'Max',
  min: 'Min',
  category: 'Category',
  close: 'Close',
  apply: 'Apply',
  amount: 'Amount',
  discount: 'Discount',
  delete: 'Delete',
  emails: 'Emails',
  do_you_want_unbind_and_delete:
    '{{dictionary}} can not be deleted. It is used for the following {{lists}}. Do you want to unbind them from the {{lists}} and to delete this {{dictionary}}?',
  mailing_message:
    'The email dispatch is carried out in a separate process.\n \nAfter process is finished you will\n \nreceive a notification.',
  emails_sent_successfully: 'Emails sent successfully: {{successCount}}',
  emails_failed_to_send: 'Emails failed to send: {{failureCount}}',
  error_while_sending_emails: 'An error occurred while sending emails. Please try again later.',
  previous_record: 'Previous record',
  next_record: 'Next record',
  quantity: 'Quantity',
  correction_quantity: 'Correction quantity',
  yes: 'Yes',
  no: 'No',
  new_record: 'New record',
  report_is_generating_now: 'Report is generating now. Please try again later',
  difference: 'Difference',
  discard_your_changes: 'Discard your changes?',
  discard: 'Discard',
  list_are_not_configured: 'Lists are not configured',
  click_button_above_to_configure: 'Click the <icon /> button above to configure',
  track: 'Track',
  sender_address: 'Sender’s address',
  receiver_address: 'Receiver’s address',
  subject: 'Subject',
  diagnostic_information: 'Diagnostic information',
  delivery_information_is_not_yet_available:
    'Delivery information is not yet available, please try again later!',
  invoice_dates_range: 'Invoice dates range',
  data_processing: 'Data processing...',
  price: 'Price',
  price_pre_discount: 'Price (orig.)',
  price_after_discount: 'Price (disc.)',
  total: 'Total',
  total_pre_discount: 'Total (orig.)',
  total_after_discount: 'Total (disc.)',
  save_to_date: 'Save to date',
  round_to: 'Round to',
  new: 'New',
  for: 'For',
  serial_no: 'Serial No.',
  picture: 'Picture',
  font: 'Font',
  report_preview: 'Report preview',
  print_form: 'Print form',
  print_forms: 'Print forms',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  jan: 'Jan',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Apr',
  may_short: 'May',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Aug',
  sep: 'Sep',
  oct: 'Oct',
  nov: 'Nov',
  dec: 'Dec',
  hours: 'Hours',
  minutes: 'Minutes',
  analyzing_results: 'Analyzing... results coming soon!',
  deep_thinking: 'Deep thinking...',
  thank_you_patience: 'Thank you for your patience...',
  just_moment: 'Just a Moment...',
  crafting_perfect_result: 'Crafting the perfect result...',
  charting_optimal_path: 'Charting the optimal path...',
  calculating_best_way: 'Calculating the best way to assist you...',
  working_might_take_minute: "We're working on it. This might take up to a minute",
  almost_there: 'Almost there...',
  everything_ready_shortly: 'Everything will be ready shortly!',
  checking_final_details: 'Checking the final details...',
  request_top_priority: 'Your request is our top priority',
  contact_administrator: 'Please contact your administrator.',
  customer_not_uses_this_print_form: 'The customer was configured to not use this print form',
  translations: 'Translations',
  default: 'Default',
  translate_with_ai: 'Translate with AI',
  custom: 'Custom',
  validation_error: 'Validation error',
  version: 'Version',
  new_version_available: 'A new version is available. Please reload the page.',
});

export const commonFr = t({
  saving_error_try_again: 'Erreur lors de l’enregistrement, veuillez réessayer.',
  image_width_must_be_less_than_x_px: "La largeur de l'image doit être inférieure à {{size}} px",
  the_image_size_must_be_less_than_x_kb: "La taille de l'image doit être inférieure à {{size}} KB",
  image_height_must_be_less_than_x_px: "La hauteur de l'image doit être inférieure à {{size}} px",
  saved_successfully: 'Enregistré avec succès',
  deleting_in_progress: 'Suppression en cours',
  delete_success: 'Supprimé avec succès',
  delete_failed: 'Échec de la suppression',
  saving_in_progress: 'Enregistrement en cours',
  reason: 'Raison',
  rights: 'Droits',
  invite: 'Inviter',
  printer: 'Imprimante',
  import: 'Importer',
  finished: 'Terminé',
  company_settings: 'Paramètres de l’entreprise',
  profile_settings: 'Paramètres du profil',
  language: 'Langue',
  currency: 'Devise',
  confirmInstruction:
    'Pour continuer, veuillez saisir <strong>«Number of edited items»</strong> dans le champ ci-dessus, puis cliquer sur le bouton «Submit» ci-dessous.',
  applyConfirmation:
    'Les modifications seront appliquées définitivement au <b>{{count}} élément sélectionné</b>.',
  applyConfirmation_other:
    'Les modifications seront appliquées définitivement aux <b>{{count}} éléments sélectionnés</b>.',
  confirmation: 'Confirmation',
  do_you_agree: 'Confirmez-vous?',
  sending_to_printer: 'Envoi à l’imprimante',
  assign_printers_first: "Veuillez d'abord attribuer des imprimantes pour imprimer les formulaires",
  print_jobs_created: 'Travaux d’impression créés : {{countCreated}}',
  print_jobs_created_with_errors:
    'Travaux d’impression créés : {{countCreated}} ({{countErrors}} erreurs)',
  select_existing_customer: 'Sélectionner un client existant',
  changes_summary: 'Résumé des modifications',
  show_changes: 'Afficher les modifications',
  hide_changes: 'Masquer les modifications',
  new_values: 'Nouvelles valeurs',
  multi_edit_settings: 'Paramètres de modification multiple',
  next: 'Suivant',
  back: 'Précédent',
  submit: '	Soumettre',
  step: 'Étape',
  password: 'Mot de passe',
  settings: 'Paramètres',
  add: 'Ajouter',
  all: 'Tout',
  remove: 'Supprimer',
  thinking: 'Réflexion en cours...',
  fetching_data_from_the_cloud: 'Récupération des données depuis le cloud...',
  thank_you_for_your_patience: 'Merci pour votre patience, nous préparons la réponse parfaite...',
  just_a_moment_we_are_processing_your_request: 'Un instant, nous traitons votre demande...',
  gathering_your_data: 'Collecte de vos données...',
  analyzing_results: 'Analyse en cours... résultats bientôt disponibles !',
  deep_thinking: 'Réflexion approfondie...',
  thank_you_patience: 'Merci pour votre patience...',
  just_moment: 'Un instant...',
  crafting_perfect_result: 'Création du résultat parfait...',
  charting_optimal_path: 'Traçage du chemin optimal...',
  calculating_best_way: 'Calcul du meilleur moyen de vous aider...',
  working_might_take_minute: "Nous y travaillons. Cela peut prendre jusqu'à une minute",
  almost_there: 'Presque terminé...',
  everything_ready_shortly: 'Tout sera prêt sous peu !',
  checking_final_details: 'Vérification des derniers détails...',
  request_top_priority: 'Votre demande est notre priorité absolue',
  download_files: 'Télécharger les fichiers',
  download: 'Télécharger',
  name: 'Nom',
  street_or_post_office_box_should_be_selected: '« Rue » ou « Boîte postale » doit être rempli',
  all_types: 'Tous les types',
  number: 'Numéro',
  article: 'Article',
  search: 'Recherche',
  sort: 'Trier',
  clear: 'Effacer',
  show_filters: 'Afficher les filtres',
  hide_filters: 'Masquer les filtres',
  no_data: 'Aucune donnée',
  vat: 'TVA',
  note: 'Remarque',
  configure: 'Configurer',
  filter: 'Filtrer',
  confirm: 'Confirmer',
  font_color: 'Couleur de police',
  font_size: 'Taille de police',
  cancel: 'Annuler',
  history: 'Historique',
  current_entry: 'Entrée actuelle',
  deleted_entries: 'Entrées supprimées',
  date: 'Date',
  brutto: 'Brut',
  avatar: 'Avatar',
  net: 'Net',
  shown: 'Affiché',
  show_all: 'Afficher tout',
  user: 'Utilisateur',
  assist: 'Assister',
  cash: 'Espèces',
  wawi: 'Wawi',
  rezept: 'Recette',
  smart: 'Intelligent',
  picking: 'Prélèvement',
  restaurant: 'Restaurant',
  manager: 'Gestionnaire',
  run: 'Exécuter',
  my_resto: 'MonResto',
  console: 'Console',
  grouping: 'Regroupement',
  date_time: 'Date/Heure',
  operation: 'Opération',
  revert_changes: 'Annuler les modifications',
  username: 'Nom d’utilisateur',
  field: 'Champ',
  more_functions: 'Plus de fonctions',
  article_no: 'N° d’article',
  delivery_no: 'N° de commande',
  old_value: 'Ancienne valeur',
  new_value: 'Nouvelle valeur',
  cash_register_id: 'ID de caisse',
  cashassist: 'CashAssist',
  delivery_method: 'Méthode de livraison',
  receipt_no: 'N° de reçu',
  cashassist_user: 'Utilisateur CashAssist',
  successfully_saved: 'Enregistré avec succès',
  successfully_deleted: 'Supprimé avec succès',
  content: 'Contenu',
  lot_quantity: 'La valeur doit être un multiple du nombre de lots',
  not_empty: 'Entrée requise',
  only_numbers: 'Ne doit contenir que des chiffres',
  value_between: 'La valeur doit être comprise entre {{min}} et {{max}}',
  value_less: 'La valeur doit être inférieure à {{max}}',
  value_less_or_equal: 'La valeur ne doit pas être supérieure à {{max}}',
  value_less_999_99: 'La valeur doit être inférieure à 999,99',
  value_greater: 'La valeur doit être supérieure à {{min}}',
  no_data_in_global_search: 'Votre recherche - {{searchString}} - n’a donné aucun résultat',
  loading: 'Chargement...',
  description: 'Description',
  activated: 'Activé',
  search_failed: 'La recherche a échoué',
  search_result_for: 'Résultat de recherche pour',
  permitted: 'Autorisé',
  rules_is_not_set: 'Règles non définies',
  regional_datetime_entered_day_of_week: 'Chaque {{days}}',
  in_period: 'en période',
  repeat_yearly: 'Répéter chaque année',
  in_periods: 'dans les périodes {{periods}}',
  vacation: 'Vacances',
  not_delivered: 'Non livré',
  from_date: 'À partir de la date',
  to_date: 'À la date',
  yearly: 'Annuel',
  change: 'Changer',
  fri: 'Ve',
  mon: 'Lu',
  sat: 'Sa',
  sun: 'Di',
  thu: 'Je',
  tue: 'Ma',
  wed: 'Me',
  forbidden: 'Interdit',
  address: 'Adresse',
  enter_delivery_address: 'Entrez l’adresse de livraison',
  empty: 'Vide',
  export: 'Exporter',
  print: 'Imprimer',
  print_all: 'Imprimer tout',
  email: 'Email',
  delivery_note: 'Bon de livraison',
  invoice: 'Facture',
  preview: 'Aperçu',
  preview_all: 'Aperçu complet',
  successfully: 'Avec succès',
  server_error: 'Erreur serveur',
  multiselect: 'Sélection multiple',
  proceed_anyway: 'Continuer quand même',
  warning: 'Avertissement',
  current_month: 'Mois actuel',
  last_month: 'Le mois dernier',
  date_range: 'Plage de dates',
  customer: 'Client',
  customer_no: 'N° client',
  customers_group: 'Groupe de clients',
  customers_list: 'Liste de clients',
  one_time_customers: 'Client ponctuel',
  open_emails: 'Emails non envoyés',
  sending_emails: 'Envoi des emails en cours',
  sent_emails: 'Emails envoyés',
  show_deleted: 'Afficher supprimés',
  from: 'De',
  to: 'À',
  pdf_history: 'Historique PDF',
  pdfs_versions: 'Historique des PDFs',
  created: 'Créé',
  report: 'Rapport',
  ok: 'Ok',
  invalid_data_warning:
    'Les données sont invalides. Vos modifications seront perdues. Voulez-vous continuer?',
  sending: 'Envoi...',
  save: 'Enregistrer',
  send: 'Envoyer',
  email_sent_successfully: 'Email envoyé avec succès',
  email_sent_successfully_other: 'Emails envoyés avec succès',
  problem_while_sending_email: 'Problème lors de l’envoi de l’email',
  problem_while_sending_email_other: 'Problème lors de l’envoi des emails',
  order: 'Commande',
  offer: 'Offre',
  recipient: 'Destinataire',
  regarding: 'Concernant',
  message: 'Message',
  facilities: 'Installations',
  number_short: 'N°',
  offline: 'Vous êtes hors ligne',
  internet_restored: 'Connexion internet rétablie',
  new_version_installed:
    'Félicitations 🎉 La mise à jour vers la nouvelle version a été effectuée avec succès !',
  update: 'Mettre à jour',
  session_expired: 'Session expirée',
  sign_out: 'Se déconnecter',
  signed_out_refresh: 'Vous êtes déconnecté. Actualisez la page pour continuer à travailler.',
  refresh: 'Rafraîchir',
  reload_page: 'Recharger la page',
  monday: 'Lundi',
  tuesday: 'Mardi',
  wednesday: 'Mercredi',
  thursday: 'Jeudi',
  friday: 'Vendredi',
  saturday: 'Samedi',
  sunday: 'Dimanche',
  replace: 'Remplacer',
  weekAgo: 'Il y a une semaine',
  twoWeeksAgo: 'Il y a deux semaines',
  threeWeeksAgo: 'Il y a trois semaines',
  error_customer_info_not_loaded: 'Les informations du client n’ont pas été chargées!',
  error_orders_not_loaded: 'La commande n’a pas été chargée!',
  error_customer_list_not_loaded: 'La liste des clients n’a pas été chargée!',
  error_chnages_not_saved: 'Erreur. Vos modifications n’ont pas été enregistrées.',
  changes_you_made_were_not_saved:
    'Les modifications que vous avez faites n’ont pas été enregistrées. Voulez-vous continuer?',
  all_lists: 'Toutes les listes',
  default_settings: 'Paramètres par défaut',
  additional: 'Supplémentaire',
  days: 'Jours',
  enter_valid_email: 'Veuillez entrer une adresse email correcte',
  update_browser_heading: 'Mettez à jour votre navigateur',
  update_browser_message:
    'Malheureusement, vous utilisez un navigateur obsolète.<br />Veuillez mettre à jour votre navigateur pour améliorer votre expérience et votre sécurité.',
  link_current_browser_versions: 'Liens vers les versions actuelles des navigateurs:',
  max: 'Max',
  min: 'Min',
  category: 'Catégorie',
  close: 'Fermer',
  apply: 'Appliquer',
  amount: 'Montant',
  discount: 'Remise',
  delete: 'Supprimer',
  emails: 'Emails',
  do_you_want_unbind_and_delete:
    '{{dictionary}} ne peut pas être supprimé. Il est utilisé pour les {{lists}} suivants. Voulez-vous les dissocier des {{lists}} et supprimer ce {{dictionary}}?',
  mailing_message:
    'L’envoi des emails se fait dans un processus distinct.\n \nUne fois le processus terminé, vous\n \nrecevrez une notification.',
  emails_sent_successfully: 'Emails envoyés avec succès: {{successCount}}',
  emails_failed_to_send: 'Emails non envoyés: {{failureCount}}',
  error_while_sending_emails:
    'Une erreur s’est produite lors de l’envoi des emails. Veuillez réessayer plus tard.',
  previous_record: 'Enregistrement précédent',
  next_record: 'Enregistrement suivant',
  quantity: 'Quantité',
  correction_quantity: 'Quantité de correction',
  yes: 'Oui',
  no: 'Non',
  new_record: 'Nouvel enregistrement',
  report_is_generating_now: 'Le rapport est en cours de génération. Veuillez réessayer plus tard',
  difference: 'Différence',
  discard_your_changes: 'Annuler vos modifications?',
  discard: 'Annuler',
  list_are_not_configured: 'La liste n’est pas configurée',
  click_button_above_to_configure: 'Cliquez sur le bouton <icon /> ci-dessus pour configurer',
  track: 'Suivre',
  sender_address: 'Adresse de l’expéditeur',
  receiver_address: 'Adresse du destinataire',
  subject: 'Objet',
  diagnostic_information: 'Informations de diagnostic',
  delivery_information_is_not_yet_available:
    'Les informations de livraison ne sont pas encore disponibles, veuillez réessayer plus tard!',
  invoice_dates_range: 'Plage de dates des factures',
  data_processing: 'Traitement des données...',
  price: 'Prix',
  price_pre_discount: 'Prix (av. rem.)',
  price_after_discount: 'Prix (ap. rem.)',
  total: 'Total',
  total_pre_discount: 'Total (av. rem.)',
  total_after_discount: 'Total (ap. rem.)',
  save_to_date: 'Enregistrer à la date',
  round_to: 'Arrondir à',
  new: 'Nouvel',
  for: 'Pour',
  serial_no: 'N° de série',
  picture: 'Image',
  font: 'Fonte',
  report_preview: 'Aperçu du rapport',
  print_form: "Formulaire d'impression",
  print_forms: "Formulaires d'impression",
  january: 'janvier',
  february: 'février',
  march: 'mars',
  april: 'avril',
  may: 'mai',
  june: 'juin',
  july: 'juillet',
  august: 'août',
  september: 'septembre',
  october: 'octobre',
  november: 'novembre',
  december: 'décembre',
  jan: 'janv.',
  feb: 'févr.',
  mar: 'mars',
  apr: 'avr.',
  may_short: 'mai',
  jun: 'juin',
  jul: 'juil.',
  aug: 'août',
  sep: 'sept.',
  oct: 'oct.',
  nov: 'nov.',
  dec: 'déc.',
  hours: 'Heures',
  minutes: 'Minutes',
  contact_administrator: 'Veuillez contacter votre administrateur.',
  customer_not_uses_this_print_form:
    'Le client a été configuré pour ne pas utiliser ce modèle d’impression',
  translations: 'Traductions',
  default: 'défaut',
  translate_with_ai: 'Traduire avec l’IA',
  custom: 'Personnalisé',
  validation_error: 'Erreur de validation',
  version: 'Version',
  new_version_available: 'Une nouvelle version est disponible. Veuillez recharger la page.',
});

export const commonIt = t({
  saving_error_try_again: 'Errore durante il salvataggio, riprova.',
  the_image_size_must_be_less_than_x_kb:
    "La dimensione dell'immagine deve essere inferiore a {{size}} KB",
  image_width_must_be_less_than_x_px:
    "La larghezza dell'immagine deve essere inferiore a {{size}} px",
  image_height_must_be_less_than_x_px:
    "L'altezza dell'immagine deve essere inferiore a {{size}} px",
  saved_successfully: 'Salvato con successo',
  deleting_in_progress: 'Eliminazione in corso',
  delete_success: 'Eliminato con successo',
  delete_failed: 'Eliminazione non riuscita',
  saving_in_progress: 'Salvataggio in corso',
  reason: 'Motivo',
  rights: 'Diritti',
  invite: 'Invita',
  printer: 'Stampante',
  import: 'Importa',
  finished: 'Completato',
  confirmInstruction:
    'Per procedere, digita <strong>"Number of edited items"</strong> nel campo sopra e fai clic sul pulsante "Submit" qui sotto.',
  applyConfirmation:
    'Le modifiche verranno applicate in modo permanente al <b>{{count}} elemento selezionato</b>.',
  applyConfirmation_other:
    'Le modifiche verranno applicate in modo permanente ai <b>{{count}} elementi selezionati</b>.',
  confirmation: 'Conferma',
  company_settings: 'Impostazioni aziendali',
  profile_settings: 'Impostazioni del profilo',
  language: 'Lingua',
  currency: 'Valuta',
  do_you_agree: 'Confermi?',
  sending_to_printer: 'Invio alla stampante',
  assign_printers_first: 'Assegna prima le stampanti per stampare i moduli',
  print_jobs_created: 'Processi di stampa creati: {{countCreated}}',
  print_jobs_created_with_errors:
    'Processi di stampa creati: {{countCreated}} ({{countErrors}} errori)',
  select_existing_customer: 'Seleziona un cliente esistente',
  changes_summary: 'Riepilogo modifiche',
  show_changes: 'Mostra modifiche',
  hide_changes: 'Nascondi modifiche',
  new_values: 'Nuovi valori',
  multi_edit_settings: 'Impostazioni di modifica multipla',
  next: 'Avanti',
  back: 'Indietro',
  submit: 'Invia',
  step: 'Passaggio',
  password: 'Password',
  settings: 'Impostazioni',
  add: 'Aggiungi',
  all: 'Tutto',
  all_types: 'Tutti i tipi',
  remove: 'Rimuovi',
  name: 'Nome',
  number: 'Numero',
  search: 'Cerca',
  thinking: 'Riflettendo...',
  fetching_data_from_the_cloud: 'Recupero dei dati dal cloud...',
  thank_you_for_your_patience: 'Grazie per la pazienza, stiamo creando la risposta perfetta...',
  just_a_moment_we_are_processing_your_request: 'Un momento, stiamo elaborando la tua richiesta...',
  gathering_your_data: 'Raccolta dei tuoi dati...',
  analyzing_results: 'Analisi in corso... risultati in arrivo!',
  deep_thinking: 'Pensiero profondo...',
  thank_you_patience: 'Grazie per la pazienza...',
  just_moment: 'Un momento...',
  crafting_perfect_result: 'Creazione del risultato perfetto...',
  charting_optimal_path: 'Tracciando il percorso ottimale...',
  calculating_best_way: 'Calcolando il modo migliore per aiutarti...',
  working_might_take_minute: 'Ci stiamo lavorando. Potrebbe volerci fino a un minuto',
  almost_there: 'Quasi fatto...',
  everything_ready_shortly: 'Tutto sarà pronto a breve!',
  checking_final_details: 'Verifica dei dettagli finali...',
  request_top_priority: 'La tua richiesta è la nostra massima priorità',
  sort: 'Ordina',
  download: 'Scarica',
  clear: 'Pulisci',
  no_data: 'Nessun dato',
  vat: 'IVA',
  street_or_post_office_box_should_be_selected:
    'Il campo "Via" o "Casella postale" deve essere compilato',
  article: 'Articolo',
  note: 'Nota',
  show_filters: 'Mostra filtri',
  hide_filters: 'Nascondi filtri',
  configure: 'Configura',
  filter: 'Filtro',
  confirm: 'Conferma',
  font_color: 'Colore del carattere',
  font_size: 'Dimensione del carattere',
  cancel: 'Annulla',
  history: 'Cronologia',
  current_entry: 'Voce corrente',
  deleted_entries: 'Voci eliminate',
  date: 'Data',
  brutto: 'Lordo',
  avatar: 'Avatar',
  net: 'Netto',
  shown: 'Mostrato',
  show_all: 'Mostra tutto',
  user: 'Utente',
  download_files: 'Scarica i file',
  assist: 'Assistenza',
  cash: 'Contanti',
  wawi: 'WaWi',
  rezept: 'Ricetta',
  smart: 'Intelligente',
  picking: 'Picking',
  restaurant: 'Ristorante',
  manager: 'Gestore',
  run: 'Esegui',
  my_resto: 'MyResto',
  console: 'Console',
  grouping: 'Raggruppamento',
  date_time: 'Data/Ora',
  operation: 'Operazione',
  revert_changes: 'Annulla modifiche',
  username: 'Nome utente',
  field: 'Campo',
  more_functions: 'Altre funzioni',
  article_no: 'N. Articolo',
  delivery_no: 'N. Ordine',
  old_value: 'Vecchio valore',
  new_value: 'Nuovo valore',
  cash_register_id: 'ID Cassa',
  cashassist: 'CashAssist',
  delivery_method: 'Metodo di consegna',
  receipt_no: 'N. Ricevuta',
  cashassist_user: 'Utente CashAssist',
  successfully_saved: 'Salvato con successo',
  successfully_deleted: 'Eliminato con successo',
  content: 'Contenuto',
  lot_quantity: 'Il valore deve essere un multiplo del numero di lotti',
  not_empty: 'Inserimento richiesto',
  only_numbers: 'Deve contenere solo numeri',
  value_between: 'Il valore deve essere compreso tra {{min}} e {{max}}',
  value_less: 'Il valore deve essere inferiore a {{max}}',
  value_less_or_equal: 'Il valore non deve essere superiore a {{max}}',
  value_less_999_99: 'Il valore deve essere inferiore a 999,99',
  value_greater: 'Il valore deve essere maggiore di {{min}}',
  no_data_in_global_search: 'La tua ricerca - {{searchString}} - non ha prodotto risultati',
  loading: 'Caricamento...',
  description: 'Descrizione',
  activated: 'Attivato',
  search_failed: 'Ricerca fallita',
  search_result_for: 'Risultato della ricerca per',
  permitted: 'Permesso',
  rules_is_not_set: 'Le regole non sono impostate',
  regional_datetime_entered_day_of_week: 'Ogni {{days}}',
  in_period: 'nel periodo',
  repeat_yearly: 'Ripeti ogni anno',
  in_periods: 'nei periodi {{periods}}',
  vacation: 'Vacanza',
  not_delivered: 'Non consegnato',
  from_date: 'Dalla data',
  to_date: 'Alla data',
  yearly: 'Annuale',
  change: 'Modifica',
  fri: 'Ve',
  mon: 'Lu',
  sat: 'Sa',
  sun: 'Do',
  thu: 'Gi',
  tue: 'Ma',
  wed: 'Me',
  forbidden: 'Vietato',
  address: 'Indirizzo',
  enter_delivery_address: "Inserisci l'indirizzo di consegna",
  empty: 'Vuoto',
  export: 'Esporta',
  print: 'Stampa',
  print_all: 'Stampa tutto',
  email: 'Email',
  delivery_note: 'Bolla di consegna',
  invoice: 'Fattura',
  preview: 'Anteprima',
  preview_all: 'Anteprima tutto',
  successfully: 'Con successo',
  server_error: 'Errore del server',
  multiselect: 'Selezione multipla',
  proceed_anyway: 'Procedi comunque',
  warning: 'Avviso',
  current_month: 'Mese corrente',
  last_month: 'Mese scorso',
  date_range: 'Intervallo di date',
  customer: 'Cliente',
  customer_no: 'N. Cliente',
  customers_group: 'Gruppo clienti',
  customers_list: 'Elenco clienti',
  one_time_customers: 'Cliente occasionale',
  open_emails: 'Email non inviate',
  sending_emails: 'Invio delle email in corso',
  sent_emails: 'Email inviate',
  show_deleted: 'Mostra eliminati',
  from: 'Da',
  to: 'A',
  pdf_history: 'Storico PDF',
  pdfs_versions: 'Versioni PDF',
  created: 'Creato',
  report: 'Rapporto',
  ok: 'Ok',
  invalid_data_warning: 'Dati non validi. Le tue modifiche verranno perse. Vuoi procedere?',
  sending: 'Invio...',
  save: 'Salva',
  send: 'Invia',
  email_sent_successfully: 'Email inviata con successo',
  email_sent_successfully_other: 'Email inviate con successo',
  problem_while_sending_email: "Problema durante l'invio dell'email",
  problem_while_sending_email_other: "Problema durante l'invio delle email",
  order: 'Ordine',
  offer: 'Offerta',
  recipient: 'Destinatario',
  regarding: 'Riguardo',
  message: 'Messaggio',
  facilities: 'Strutture',
  number_short: 'N.',
  offline: 'Sei offline',
  internet_restored: 'Connessione a Internet ripristinata',
  new_version_installed:
    "Congratulazioni 🎉 L'aggiornamento alla nuova versione è riuscito con successo!",
  update: 'Aggiorna',
  session_expired: 'Sessione scaduta',
  sign_out: 'Disconnetti',
  signed_out_refresh: 'Sei stato disconnesso. Aggiorna la pagina per continuare.',
  refresh: 'Aggiorna',
  reload_page: 'Ricarica la pagina',
  monday: 'Lunedì',
  tuesday: 'Martedì',
  wednesday: 'Mercoledì',
  thursday: 'Giovedì',
  friday: 'Venerdì',
  saturday: 'Sabato',
  sunday: 'Domenica',
  replace: 'Sostituisci',
  weekAgo: 'Una settimana fa',
  twoWeeksAgo: 'Due settimane fa',
  threeWeeksAgo: 'Tre settimane fa',
  error_customer_info_not_loaded: 'Le informazioni del cliente non sono state caricate!',
  error_orders_not_loaded: "L'ordine non è stato caricato!",
  error_customer_list_not_loaded: "L'elenco clienti non è stato caricato!",
  error_chnages_not_saved: 'Errore. Le tue modifiche non sono state salvate.',
  changes_you_made_were_not_saved: 'Le modifiche apportate non sono state salvate. Vuoi procedere?',
  all_lists: 'Tutti gli elenchi',
  default_settings: 'Impostazioni predefinite',
  additional: 'Aggiuntivo',
  days: 'Giorni',
  enter_valid_email: 'Inserisci un indirizzo email corretto',
  update_browser_heading: 'Aggiorna il tuo browser',
  update_browser_message:
    "Purtroppo stai utilizzando un browser obsoleto.<br />Aggiorna il tuo browser per migliorare l'esperienza e la sicurezza.",
  link_current_browser_versions: 'Link delle versioni attuali del browser:',
  max: 'Max',
  min: 'Min',
  category: 'Categoria',
  close: 'Chiudi',
  apply: 'Applica',
  amount: 'Importo',
  discount: 'Sconto',
  delete: 'Elimina',
  emails: 'Email',
  do_you_want_unbind_and_delete:
    '{{dictionary}} non può essere eliminato. È utilizzato nei seguenti {{lists}}. Vuoi scollegarli dai {{lists}} e eliminare questo {{dictionary}}?',
  mailing_message:
    "L'invio delle email viene effettuato in un processo separato.\n \nDopo il completamento del processo riceverai\n \nuna notifica.",
  emails_sent_successfully: 'Email inviate con successo: {{successCount}}',
  emails_failed_to_send: 'Email non inviate: {{failureCount}}',
  error_while_sending_emails:
    "Si è verificato un errore durante l'invio delle email. Riprova più tardi.",
  previous_record: 'Record precedente',
  next_record: 'Record successivo',
  quantity: 'Quantità',
  correction_quantity: 'Quantità di correzione',
  yes: 'Sì',
  no: 'No',
  new_record: 'Nuovo record',
  report_is_generating_now: 'Il rapporto è in fase di generazione. Riprova più tardi',
  difference: 'Differenza',
  discard_your_changes: 'Scartare le tue modifiche?',
  discard: 'Scarta',
  list_are_not_configured: 'La lista non è configurata',
  click_button_above_to_configure: 'Clicca sul pulsante <icon /> sopra per configurare',
  track: 'Traccia',
  sender_address: 'Indirizzo del mittente',
  receiver_address: 'Indirizzo del destinatario',
  subject: 'Oggetto',
  diagnostic_information: 'Informazioni diagnostiche',
  delivery_information_is_not_yet_available:
    'Le informazioni di consegna non sono ancora disponibili, riprova più tardi!',
  invoice_dates_range: 'Intervallo date fattura',
  data_processing: 'Elaborazione dati...',
  price: 'Prezzo',
  price_pre_discount: 'Prezzo (orig.)',
  price_after_discount: 'Prezzo (scont.)',
  total: 'Totale',
  total_pre_discount: 'Totale (orig.)',
  total_after_discount: 'Totale (scont.)',
  save_to_date: 'Salva alla data',
  round_to: 'Arrotonda a',
  new: 'Nuovo',
  for: 'Per',
  serial_no: 'N. di serie',
  picture: 'Immagine',
  font: 'Font',
  report_preview: 'Anteprima del rapporto',
  print_form: 'Modulo di stampa',
  print_forms: 'Moduli di stampa',
  january: 'gennaio',
  february: 'febbraio',
  march: 'marzo',
  april: 'aprile',
  may: 'maggio',
  june: 'giugno',
  july: 'luglio',
  august: 'agosto',
  september: 'settembre',
  october: 'ottobre',
  november: 'novembre',
  december: 'dicembre',
  jan: 'gen',
  feb: 'feb',
  mar: 'mar',
  apr: 'apr',
  may_short: 'mag',
  jun: 'giu',
  jul: 'lug',
  aug: 'ago',
  sep: 'set',
  oct: 'ott',
  nov: 'nov',
  dec: 'dic',
  hours: 'Ore',
  minutes: 'Minuti',
  contact_administrator: 'Contatta il tuo amministratore.',
  customer_not_uses_this_print_form:
    'Il cliente è stato configurato per non utilizzare questo modulo di stampa',
  translations: 'Traduzioni',
  default: 'predefinita',
  translate_with_ai: 'Traduci con AI',
  custom: 'Personalizzato',
  validation_error: 'Errore di validazione',
  version: 'Versione',
  new_version_available: 'È disponibile una nuova versione. Ricarica la pagina.',
});
